module.exports = __webpack_public_path__ + "static/img/interestFree.420f799.png";


//////////////////
// WEBPACK FOOTER
// ./static/runtime/images/magic/interestFree.png
// module id = JU3A
// module chunks = 1